import { useEffect, useState } from 'react';
import { Button } from './Button';
import { Input } from './Input';
import { useServiceMode } from 'src/contexts/ServiceModeContext';
import { getAuth } from 'firebase/auth';

export const ServiceModeForm = (props: { onChange: (val: object) => void }) => {
  const { onChange } = props;
  const [orgId, setOrgId] = useState<string>('');
  const { generateServiceKey, revokeServiceKey, overrideEnvId } =
    useServiceMode();
  const [envId, setEnvId] = useState<string>(overrideEnvId || '');
  const [hasSuperAdminRole, setHasSuperAdminRole] = useState(false);
  const auth = getAuth();

  const checkServiceModeAccess = async () => {
    const resp = await auth.currentUser?.getIdTokenResult();
    if (!resp || !process.env.REACT_APP_SUPER_ADMIN_ROLE_ID) {
      return;
    }
    setHasSuperAdminRole(
      (resp.claims.roles as [{ id: string }]).filter(
        (role) => role.id === process.env.REACT_APP_SUPER_ADMIN_ROLE_ID,
      ).length > 0,
    );
  };

  useEffect(() => {
    checkServiceModeAccess();
  }, []);

  useEffect(() => {
    if (!overrideEnvId) {
      return;
    }
    setEnvId(overrideEnvId);
  }, [overrideEnvId]);

  if (!hasSuperAdminRole) {
    return null;
  }

  return (
    <>
      <div>
        <Input
          label="Override Org ID"
          value={orgId}
          className="text-neutral-600"
          onChange={(evt) => setOrgId(evt.target.value)}
        />
      </div>
      <div>
        <Input
          label="Override Env ID"
          value={envId}
          className="text-neutral-600"
          onChange={(evt) => setEnvId(evt.target.value)}
        />
      </div>
      <Button
        onClick={async () => {
          await generateServiceKey(envId, orgId);
          onChange({ orgId, envId });
        }}
      >
        Enter Service Mode
      </Button>
      <Button
        onClick={async () => {
          await revokeServiceKey();
          onChange({ orgId, envId });
        }}
      >
        Exit Service Mode
      </Button>
    </>
  );
};
